(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("nc", [], factory);
	else if(typeof exports === 'object')
		exports["nc"] = factory();
	else
		root["nc"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 